import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';

import { getUser, getAccessToken } from './service/AuthService';


//TODO: move this to an environment variable
const importUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/importresources';


const ImportResources = () => {
    const user = getUser();
    const token = getAccessToken();
    const username = user !== 'undefined' && user ? user.username: '';

    // const [learningContent, setLearningContent] = useState('');
    // const [goals, setGoals] = useState('');
    // const [journalPrompts, setJournalPrompts] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [learningInput, setLearningInput] = useState([{ modulename: '', order: '', name: '', description: '', url: '', type: '', tags: '', textcontent: ''}])
    const [journalInput, setJournalInput] = useState([{ modulename: '', order: '', name: '', description: '', type: '', tags: '', textcontent: ''}])
    const [goalInput, setGoalInput] = useState([{ modulename: '', order: '', name: '', description: '', type: '', tags: '', textcontent: '', notifications: ''}])


    const navigate = useNavigate();

    const submitHandler = (event) => {
        event.preventDefault();
        //console.log('learningInput')
        //console.log(learningInput)
        //console.log('journalInput')
        //console.log(journalInput)
        //console.log('goalInput')
        //console.log(goalInput)
        //TODO: add error messaging
        setErrorMessage(null)
        
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            username: username,
            token: token,
            learningInput: learningInput,
            journalInput: journalInput,
            goalInput: goalInput,
        }

        //console.log(requestBody)

        axios.post(importUrl, requestBody, requestConfig).then(response => {
            // setUserSession(response.data.user, response.data.token);
            //console.log('success')
            //console.log(response)
            navigate('/daily-content');
        }).catch(error => {
            //console.log(error)
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
    }

    const addInputElem = (divClassName) => {
        if (divClassName === 'educational-content'){
            let newfield = { modulename: '', order: '', name: '', description: '', url: '', type: '', tags: '', textcontent: '' }
            setLearningInput([...learningInput, newfield])
        }
        if (divClassName === 'journal-prompts'){
            let newfield = { modulename: '', order: '', name: '', description: '', type: '', tags: '', textcontent: '' }
            setJournalInput([...journalInput, newfield])
        }
        if (divClassName === 'goal-regimen'){
            let newfield = { modulename: '', order: '', name: '', description: '', type: '', tags: '', textcontent: '', notifications: '' }
            setGoalInput([...goalInput, newfield])
        }
    }

    const handleLearningChange = (index, event) => {
        let data = [...learningInput];
        data[index][event.target.name] = event.target.value;
        setLearningInput(data);
    }

    const handlePromptChange = (index, event) => {
        let data = [...journalInput];
        data[index][event.target.name] = event.target.value;
        setJournalInput(data);
    }

    const handleGoalChange = (index, event) => {
        let data = [...goalInput];
        data[index][event.target.name] = event.target.value;
        setGoalInput(data);
    }

    // const learningInput =  document.getElementsByClassName('educational-content')[0].getElementsByTagName('input')[0]
    // const journalInput =  document.getElementsByClassName('journal-prompts')[0].getElementsByTagName('input')[0]
    // const goalInput =  document.getElementsByClassName('goal-regimen')[0].getElementsByTagName('input')[0]
    
    // learningInput.onclick = addInputElem('educational-content');
    // journalInput.onclick = addInputElem('journal-prompts');
    // goalInput.onclick = addInputElem('goal-regimen');


    return (
        <div className="container">
            <form onSubmit = { submitHandler }>
                 <div className="form-mask">
                    <div className="form-contents">
                        <h5>Import Content (all comma separated) - recommended to add full modules</h5>
                        Educational Content<br />
                        <div className="form-group educational-content"> 
                            {/* <label> fields: module name, order, name, description, url, type, tags, textcontent </label> <br/>  */}
                            {/* <input type="text" value={learningContent} onChange={event => setLearningContent(learningContent + '\n' + event.target.value)} /> <br /> */}
                            {learningInput.map((input, index) => {
                                return (
                                    <div key={index}>
                                        <input
                                            name='modulename'
                                            placeholder='Module Name'
                                            value={input.modulename}
                                            onChange={event => handleLearningChange(index, event)}
                                        />
                                        <input
                                            name='order'
                                            placeholder='Order'
                                            value={input.order}
                                            onChange={event => handleLearningChange(index, event)}
                                        />
                                        <input
                                            name='name'
                                            placeholder='Name'
                                            value={input.name}
                                            onChange={event => handleLearningChange(index, event)}
                                        />
                                        <input
                                            name='description'
                                            placeholder='Description'
                                            value={input.description}
                                            onChange={event => handleLearningChange(index, event)}
                                        />
                                        <input
                                            name='url'
                                            placeholder='Url'
                                            value={input.url}
                                            onChange={event => handleLearningChange(index, event)}
                                        />
                                        <input
                                            name='type'
                                            placeholder='Type'
                                            value={input.type}
                                            onChange={event => handleLearningChange(index, event)}
                                        />
                                        <input
                                            name='tags'
                                            placeholder='Tags'
                                            value={input.tags}
                                            onChange={event => handleLearningChange(index, event)}
                                        />
                                        <input
                                            name='textcontent'
                                            placeholder='Text Content'
                                            value={input.textcontent}
                                            onChange={event => handleLearningChange(index, event)}
                                        />
                                        <br/>
                                    </div>
                                )
                            })}
                            <div className="form-group"><button className="submit-bttn" type= "button" onClick= {() => addInputElem('educational-content')}> Add more </button><br /></div>
                        </div>
                        <br />
                        Journal Prompts<br />
                        <div className="form-group journal-prompts"> 
                            <br/> 
                            {/* <input type="text" value={journalPrompts} onChange={event => setJournalPrompts(journalPrompts + '\n' + event.target.value)} />  */}
                            {journalInput.map((input, index) => {
                                return (
                                    <div key={index}>
                                        <input
                                            name='modulename'
                                            placeholder='Module Name'
                                            value={input.modulename}
                                            onChange={event => handlePromptChange(index, event)}
                                        />
                                        <input
                                            name='order'
                                            placeholder='Order'
                                            value={input.order}
                                            onChange={event => handlePromptChange(index, event)}
                                        />
                                        <input
                                            name='name'
                                            placeholder='Name'
                                            value={input.name}
                                            onChange={event => handlePromptChange(index, event)}
                                        />
                                        <input
                                            name='description'
                                            placeholder='Description'
                                            value={input.description}
                                            onChange={event => handlePromptChange(index, event)}
                                        />
                                        <input
                                            name='type'
                                            placeholder='Type'
                                            value={input.type}
                                            onChange={event => handlePromptChange(index, event)}
                                        />
                                        <input
                                            name='tags'
                                            placeholder='Tags'
                                            value={input.tags}
                                            onChange={event => handlePromptChange(index, event)}
                                        />
                                        <input
                                            name='textcontent'
                                            placeholder='Text Content'
                                            value={input.textcontent}
                                            onChange={event => handlePromptChange(index, event)}
                                        />
                                        <br/>
                                    </div>
                                )
                            })}
                            <div className="form-group"><button className="submit-bttn" type= "button" onClick= {() => addInputElem('journal-prompts')}> Add more </button><br /></div>
                        </div>
                        <br />
                        Goal Regimen<br />
                        <div className="form-group goal-regimen"> 
                            <br/> 
                            {/* <input type="text" value={goals} onChange={event => setGoals(goals + '\n' + event.target.value)} />  */}
                            {goalInput.map((input, index) => {
                                return (
                                    <div key={index}>
                                        <input
                                            name='modulename'
                                            placeholder='Module Name'
                                            value={input.modulename}
                                            onChange={event => handleGoalChange(index, event)}
                                        />
                                        <input
                                            name='order'
                                            placeholder='Order'
                                            value={input.order}
                                            onChange={event => handleGoalChange(index, event)}
                                        />
                                        <input
                                            name='name'
                                            placeholder='Name'
                                            value={input.name}
                                            onChange={event => handleGoalChange(index, event)}
                                        />
                                        <input
                                            name='description'
                                            placeholder='Description'
                                            value={input.description}
                                            onChange={event => handleGoalChange(index, event)}
                                        />
                                        <input
                                            name='type'
                                            placeholder='Type'
                                            value={input.type}
                                            onChange={event => handleGoalChange(index, event)}
                                        />
                                        <input
                                            name='tags'
                                            placeholder='Tags'
                                            value={input.tags}
                                            onChange={event => handleGoalChange(index, event)}
                                        />
                                        <input
                                            name='textcontent'
                                            placeholder='Text Content'
                                            value={input.textcontent}
                                            onChange={event => handleGoalChange(index, event)}
                                        />
                                        <input
                                            name='notifications'
                                            placeholder='Notifications'
                                            value={input.notifications}
                                            onChange={event => handleGoalChange(index, event)}
                                        />
                                        <br/>
                                    </div>
                                )
                            })}
                            <br />
                            <div className="form-group"><button className="submit-bttn" type= "button" onClick= {() => addInputElem('goal-regimen')}> Add more </button><br /></div>
                        </div>
                        <br />
                        {errorMessage && <p className="message"> { errorMessage } </p>}
                        <div className="form-group"><input className="submit-bttn" type="submit" /><br /></div>
                    </div>
                 </div>
            </form>
        </div>
    )
}


export default ImportResources;